<template>
    <div class="side-bar" :class="{ hidden: !expanded }">
        <nav class="side-bar-body" role="navigation" :aria-label="$t('Main menu')">
            <ul>
                <li>
                    <router-link class="side-bar-option" :title="$t('Home')" :to="{ name: 'home' }">
                        <span class="side-bar-option-icon">
                            <i class="fas fa-home" aria-hidden="true"></i>
                        </span>
                        <span class="side-bar-option-text">{{ $t("Home") }}</span>
                    </router-link>
                </li>

                <li v-for="section in sections" :key="section.uri">
                    <router-link
                        class="side-bar-option"
                        :class="{ selected: page === section.uri }"
                        :title="$t(section.name)"
                        :to="{ name: section.uri }"
                    >
                        <span class="side-bar-option-icon">
                            <i :class="`fas fa-${section.icon}`" aria-hidden="true"></i>
                        </span>
                        <span class="side-bar-option-text">{{ $t(section.name) }}</span>
                    </router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useVModel } from "@/utils/v-model";
import { AuthController } from "@/control/auth";
import { getSections, Section } from "@/utils/utils";

export default defineComponent({
    name: "MenuSideBar",
    emits: ["update:expanded"],
    props: {
        expanded: Boolean,
    },
    setup(props) {
        return {
            expandedStatus: useVModel(props, "expanded"),
        };
    },
    data() {
        return {
            page: "",
            userRole: AuthController.Role,
            sections: getSections() as Section[],
        };
    },
    methods: {
        updatePage() {
            this.page = (this.$route?.name as string) || "";
        },
        onAuthChanged() {
            this.userRole = AuthController.Status !== "UNAUTHORIZED" ? AuthController.Role : "";
            this.sections = getSections();
        },
    },
    mounted() {
        this.updatePage();
        this.$listenOnAppEvent("auth-status-changed", this.onAuthChanged);
    },
    watch: {
        $route() {
            this.updatePage();
        },
    },
});
</script>

<style scoped>
.side-bar-body ul{
    padding-left: 0;
    list-style: none;
}
i {
    color: var(--icon-color) !important;
}
</style>
